(ns ycweb.app.website.myaccount.addresses.addresses
  (:require
   [ycweb.components.flow :as flow]
   [rum.core :as rum]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.components.common :as cmn]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.components.grid :as grid]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.app.website.myaccount.addresses.common :as awm.addresscommon]
   [ycweb.components.toaster :as toaster]))


;; EDIT ================================================================================================================

(defmethod flow/render-screen :web.myaccount/addressedit [app-atom _]
  (awm.common/screen-wrapper app-atom
    (awm.addresscommon/addressedit app-atom)))

(defmethod t/transition-open :web.myaccount/addressedit [app-atom _ params]
  (let [action-atom (cmn/action-cursor app-atom)]
    (toaster/open-overlay app-atom :web.myaccount/address-edit)
    (swap! action-atom dissoc :address)
    (comms/ajax-get :web.myaccount/addressedit (select-keys params [:uuid]))))

(defmethod comms/receive :web.myaccount/addressedit [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/address-edit)
  (let [address (:address e)]
    (swap!
      (cmn/action-cursor app-atom) assoc
      :address
      (assoc address
        :address/setbilling (= (get-in e [:user :user/billing-address :ent/uuid]) (:ent/uuid address))
        :address/setdelivery (= (get-in e [:user :user/delivery-address :ent/uuid]) (:ent/uuid address)))
      :countries (:countries e)
      :user (:user e))))


;; ADD =================================================================================================================
(defmethod flow/render-screen :web.myaccount/addressadd [app-atom _]
  (awm.common/screen-wrapper app-atom
    (awm.addresscommon/addressedit app-atom)))

(defmethod t/transition-open :web.myaccount/addressadd [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/address-edit)
  (comms/ajax-get :web.myaccount/addressadd {}))

(defmethod comms/receive :web.myaccount/addressadd [app-atom e]
  (let [default-country-id (get-in @app-atom [:config :sa-country-id])]
    (toaster/close-overlay app-atom :web.myaccount/address-edit)
    (swap!
      (cmn/action-cursor app-atom) assoc
      :address
      (assoc (:address e) :countryid default-country-id :add? true)
      :countries (:countries e))))


;; SAVE ================================================================================================================
(defmethod grid/action :web.myaccount.address/save [app-atom config _]
  (toaster/open-toast app-atom :processing "Saving" {:closetime 10000})
  (comms/ajax-post :web.myaccount/addresssave
    {:address (:address config)}))

(defmethod comms/receive :web.myaccount/addresssave [app-atom e]
  (toaster/close-toast app-atom)
  (toaster/open-toast app-atom :success "Saved" {:closetime 2000})

  (when (:new-address? e)
    (urlstate/redirect app-atom "myaccount" "addressbook")))


;; DELETE ==============================================================================================================
(defmethod grid/action :web.myaccount.address/delete [app-atom config _]
  #?(:cljs
     (if (.confirm js/window "Are you sure you want to delete this address?")
       (do
         (toaster/open-toast app-atom :processing "Deleting" {:closetime 10000})
         (comms/ajax-get :web.myaccount/addressdelete config)))))

(defmethod comms/receive :web.myaccount/addressdelete [app-atom e]
  (toaster/close-toast app-atom)
  (swap! (cmn/action-cursor app-atom) assoc
    :addresses (:addresses e))
  (toaster/open-toast app-atom :success "Address Deleted" {:closetime 2000}))


;; CHANGE DEFAULTS =====================================================================================================
(defmethod grid/action :web.myaccount.address/changedefaultbilling [app-atom config _]
  (toaster/open-toast app-atom :processing "Updating" {:closetime 10000})
  (comms/ajax-get :web.myaccount/changedefaultbilling config))

(defmethod comms/receive :web.myaccount/changedefaultbilling [app-atom e]
  (toaster/close-toast app-atom)
  (toaster/open-toast app-atom :success "Saved" {:closetime 2000}))

(defmethod grid/action :web.myaccount.address/changedefaultdelivery [app-atom config _]
  (toaster/open-toast app-atom :processing "Updating" {:closetime 10000})
  (comms/ajax-get :web.myaccount/changedefaultdelivery config))

(defmethod comms/receive :web.myaccount/changedefaultdelivery [app-atom e]
  (toaster/close-toast app-atom)
  (toaster/open-toast app-atom :success "Saved" {:closetime 2000}))
